// images for sidebar
import dashboardIcon from '../assets/images/sidebar-dashboard-icon.svg';
import editProfileIcon from '../assets/images/sidebar-edit-profile-icon.svg';
import interViewIcon from '../assets/images/sidebar-interview-icon.svg';
import interViewProcessIcon from '../assets/images/sidebar-interview-process-icon.svg';
import jobDesignationIcon from '../assets/images/sidebar-job-designation-icon.svg';
import faqIcon from '../assets/images/sidebar-faq-icon.svg';
import AppliedJobIcon from '../assets/images/sidebar-applied-job-icon.svg';

export const LABELS = {
  WELCOME: 'Welcome to IMS portal!',
  KEEP_ME_SIGNED_IN: 'Keep me signed in',
  POWERED_BY: 'Powered by',
  FORGOT_PASSWORD: 'Forgot Password',
  RESET_PASSWORD: 'Reset Password',
  BACK_TO_LOGIN: 'Back to login',
  FORGOT_PASSWORD_LABEL:
    'Enter your email and we will send you instructions to reset your password',
  BUTTON: {
    SIGN_UP: 'Sign Up',
    SIGN_IN: 'Sign In',
    SEND: 'Send',
    SAVE: 'Save',
    SUBMIT: 'Submit',
    UPDATE_PASSWORD: 'Update Password',
    CANCEL: 'Cancel',
    SAVE_APPLICATION: 'Apply',
    EDIT: 'Edit',
    EDIT_Profile: 'Edit Profile',
    UPLOAD: 'Upload',
  },
  JOB_NOT_FOUND: 'No jobs found',
  Total_Job_Openings: 'Total Job Openings',
  Total_Applied_Jobs: 'Total Applied Jobs',
  Upcoming_Interviews: 'Upcoming Interviews',
  Profile: 'Profile',
  Current_Job_Opening_By_Experience: 'Current Job Opening by Experience',
  INPUT: {
    NAME: 'Name',
    FIRSTNAME: 'First Name',
    MIDDLENAME: 'Middle Name',
    LASTNAME: 'Last Name',
    EMAIL: 'Email Address',
    GENDER: 'Gender',
    PHONE: 'Mobile',
    ALT_PHONE: 'Alternative Contact',
    SECOND_PHONE: 'Second Mobile',
    MALE: 'Male',
    FEMALE: 'Female',
    YES: 'Yes',
    NO: 'No',
    CURRENTADDRESS: 'Current Address',
    PERMANENTADDRESS: 'Permanent Address',
    DESCRIPTION: 'Description',
    SINGLE: 'Single',
    MARRIED: 'Married',
    CURRENT_LOCATION: 'Current Location',
    MARITAL_STATUS: 'Marital Status',
    TECHNOLOGY: 'Technology',
    DOB: 'Date of Birth',
    LANGUAGE: 'Language Spoken',
    CREATE_PASSWORD: 'Create Password',
    CONFIRM_PASSWORD: 'Confirm Password',
    PASSWORD: 'Password',
    OLD_PASSWORD: 'Old Password',
    NEW_PASSWORD: 'New Password',

    RESUME: 'Resume',
    RESUME_NAME: 'Resume Name',
    RESUME_UPLOAD: 'Upload Resume',
    RESUME_UPDATE: 'Update',

    KEY_SKILLS: 'Key Skills',
    SKILLS: 'Skills',
    SOFT_SKILLS: 'Soft Skills',

    PROJECT_TITLE: 'Project Title',
    PROJECT_DETAILS: 'Project Details',
    DURATION: 'Duration (Years)',

    EDUCATION_DETAILS: 'Education Details',
    COURSE: 'Course',
    UNIVERSITY: 'University/Institute',
    GRADE: 'Grade',
    REMARKS: 'Remarks',

    JOB_TITLE: 'Job Title',
    CURRENT_EMPLOYMENT: 'Current Employment',
    CURRENT_COMPANY: 'Current Company',
    CURRENT_CTC: 'Current CTC',
    EXPEXTED_CTC: 'Expected CTC',
    NOTICE_PERIOD: 'Notice Period',
    HIGH_QUALIFICATION: 'Highest Qualification',
    EMPLOYMENT_TYPE: 'Employment Type',
    TOTAL_EXP: 'Experiance (Ex 1.05 : 1 Year 5 Months)',
    TOTAL_EXP_PLACEHOLDER: 'Ex 1.05 (1 Year 5 Months)',
    COMPANY_NAME: 'Company Name',
    JOB_LOCATION: 'Job Location',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    START_MONTH: 'Start Month',
    END_MONTH: 'End Month',
    JOINING_SALARY: 'Joining Salary',
    LAST_SALARY: 'Last Salary'
  },
  APPLY_JOBS_MSG: {
    PROFILE:
      'Kindly ensure your profile details are complete. You can update them via "Edit Profile".',
    EDUCATION: 'Make sure to fill your education details. You can do this from "Edit Profile".',
    RESUME: 'Make sure to add your resume. You can upload it through "Edit Profile".'
  }
};

export const ROUTES = {
  HOME: '/',
  REGISTER: '/signup',
  LOGIN: '/signin',
  CONTACT: '/contact',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  DASHBOARD: '/dashboard',
  INTERVIEWS: '/interviews',
  PROFILE: '/profile',
  FAQS: '/faqs',
  JOBS: '/jobs',
  APPLY_JOBS: '/apply-jobs',
  JOB_BY_ID: '/job/:id',
  JOB: '/job',
  INTERVIEW_PROCCESS: '/interview-proccess'
};

// Message-Types
export const MessageType = {
  Info: 'INFO',
  Error: 'ERROR',
  Warn: 'WARN',
  Success: 'SUCCESS'
};

// Gender
export const Gender = {
  Male: 1,
  Female: 2
};

export const DESCRIPTION_CHAR_MIN_LIMIT = 150;

export const ROLES = {
  ADMIN: 1,
  HR: 2,
  INTERVIEWER: 3,
  CANDIDATE: 4,
  HR_AND_INTERVIEWER: 5
};

export const StatusCode = {
  BadRequest: 400,
  UnAuthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  AlreadyExists: 409,
  InternalServerError: 500
};

export const INITIAL_PAGE_NUMBER = 1;

export const INITIAL_SIZE = 100;
export const INITIAL_EXPERIENCE = [0, 100];
export const INITIAL_SALARY = [0, 100];
export const INITIAL_SORT = {
  JOB: 'JobTitle',
  APPLY_JOB: 'JobTitle'
};
export const INITIAL_ORDER = {
  JOB: 'ASC',
  APPLY_JOB: 'ASC'
};
export const Profile_FILE_SIZE = 1024 * 1024;
export const Resume_FILE_SIZE = 5 * 1024 * 1024;
// Role
export const API_REQUEST = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE'
};

export const ACTION_TYPE = {
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  CANCEL: 'cancel'
};

export const PAGINATION_OPTIONS = [10, 25, 50, 100];

export const DEBOUNCE_TIMEOUT = 500;

export const APPLY_JOB_NOTE =
  'Personal details, highest education, and resume data are visible from Edit Profile section. If you want to make any changes, you need to update them from the Edit Profile section';

export const PROFILE_FORMAT_ERROR = 'Please upload an image file (png, jpeg, jpg).';
export const PROFILE_SIZE_ERROR = 'Please upload an image file smaller than 1MB.';

export const CANDIDATE_LOCATIONS = [
  { name: 'Gujarat : Ahmedabad', code: 'Gujarat : Ahmedabad' },
  { name: 'Gujarat : Bhavnagar', code: 'Gujarat : Bhavnagar' },
  { name: 'Gujarat : Jamnagar', code: 'Gujarat : Jamnagar' },
  { name: 'Gujarat : Junagadh', code: 'Gujarat : Junagadh' },
  { name: 'Gujarat : Rajkot', code: 'Gujarat : Rajkot' },
  { name: 'Gujarat : Surat', code: 'Gujarat : Surat' },
  { name: 'Gujarat : Vadodara', code: 'Gujarat : Vadodara' },
  { name: 'Gujarat : Gandhinagar', code: 'Gujarat : Gandhinagar' },
  { name: 'Madhya Pradesh : Indore', code: 'Madhya Pradesh : Indore' },
  { name: 'Madhya Pradesh : Bhopal', code: 'Madhya Pradesh : Bhopal' },
  { name: 'Rajasthan : Udaipur', code: 'Rajasthan : Udaipur' },
  { name: 'Rajasthan : Jaipur', code: 'Rajasthan : Jaipur' },
  { name: 'Other', code: 'other' }
];

export const EMPLOYMENT_TYPE = [
  { name: 'Full Time', code: 1 },
  { name: 'Part Time', code: 2 },
  { name: 'Temporary', code: 3 },
  { name: 'Interns', code: 4 },
  { name: 'Other', code: 5 }
];

export const JobModes = [
  { value: 'WFH', label: 'Work From Home' },
  { value: 'WFO', label: 'Work From Office' },
  { value: 'HYB', label: 'Hybrid' }
];

export const INTERVIEWS_COLUMNS = [
  { field: 'Interviewer Name', header: 'Interviewer Name', class: 'name-col' },
  {
    field: 'Start Date',
    header: 'Date',
    sortBy: 'StartDateOfInterviewRound',
    class: 'text-no-wrap'
  },
  { field: 'HR', header: 'HR' },
  { field: 'InterviewRound', header: 'Interview Round' },
  { field: 'Status', header: 'Status', class: 'status' },
  { field: 'Result', header: 'Result' }
];

export const EDUCATIONS_COLUMNS = [
  {
    field: 'Details',
    header: 'Name',
    class: 'name-col white-space-nowrap',
    headerClass: 'name-col white-space-nowrap'
  },
  { field: 'Course', header: 'Course', class: 'white-space-nowrap' },
  { field: 'University', header: 'University' },
  { field: 'StartDate', header: 'Start Date' },
  { field: 'EndDate', header: 'End Date' },
  { field: 'Grade', header: 'Grade' },
  { field: 'action', header: 'Action', class: 'table-action-col', headerClass: 'table-action-col' }
];

export const PROJECT_DETAILS_COLUMNS = [
  { field: 'Title', header: 'Project Title', class: 'name-col', headerClass: 'name-col' },
  { field: 'Technology', header: 'Technology' },
  {
    field: 'Duration',
    header: 'Duration',
    class: 'white-space-nowrap',
    headerClass: 'white-space-nowrap'
  },
  { field: 'action', header: 'Action', class: 'table-action-col', headerClass: 'table-action-col' }
];

// export const GRADE = [
//   { name: 'A+', code: '1' },
//   { name: 'A', code: '2' },
//   { name: 'A-', code: '3' },
//   { name: 'B+ to A-', code: '9' },
//   { name: 'B+', code: '4' },
//   { name: 'B to B+', code: '10' },
//   { name: 'B', code: '5' },
//   { name: 'B- to B', code: '11' },
//   { name: 'B-', code: '6' },
//   { name: 'C', code: '7' },
//   { name: 'N/A', code: '8' }
// ];

export const GRADE = [
  { name: 'A+ | 90-100% | 9.0 - 10.0', code: '1' },
  { name: 'A | 80-89% | 8.0 - 8.9', code: '2' },
  { name: 'A- | 75-79% | 7.5 - 7.9', code: '3' },
  { name: 'B+ | 70-74% | 7.0 - 7.4', code: '4' },
  { name: 'B | 65-69% | 6.5 - 6.9', code: '5' },
  { name: 'B- | 60-64% | 6.0 - 6.4', code: '6' },
  { name: 'C | 50-59% | 5.0 - 5.9', code: '7' },
  { name: 'N/A', code: '8' }
];

export const GRADE_CODE = {
  1: 'A+',
  2: 'A',
  3: 'A-',
  4: 'B+',
  5: 'B',
  6: 'B-',
  7: 'C',
  9: 'B+ to A-',
  10: 'B to B+',
  11: 'B- to B',
  8: 'N/A'
};

export const NOTICE_PERIOD_LABEL = [
  { label: 'Immediate', value: '0' },
  { label: '1 Month', value: '1' },
  { label: '2 Month', value: '2' },
  { label: '3 Month', value: '3' }
];

export const EMPLOYMENTS_COLUMNS = [
  { field: 'JobTitle', header: 'Name', class: 'name-col' },
  { field: 'CurrentEmployment', header: 'Current Employment' },
  { field: 'EmploymentType', header: 'Employment Type' },
  {
    field: 'TotalExperience',
    header: 'Total Exp.',
    class: 'white-space-nowrap',
    headerClass: 'white-space-nowrap'
  },
  { field: 'CompanyName', header: 'Company Name' },
  { field: 'JobLocation', header: 'Job Location' },
  {
    field: 'StartDate',
    header: 'Start Date',
    class: 'white-space-nowrap',
    headerClass: 'white-space-nowrap'
  },
  {
    field: 'EndDate',
    header: 'End Date',
    class: 'white-space-nowrap',
    headerClass: 'white-space-nowrap'
  },
  { field: 'JoiningSalary', header: 'Joining Salary' },
  { field: 'LastSalary', header: 'Last Salary' },
  { field: 'action', header: 'Action', class: 'table-action-col', headerClass: 'table-action-col' }
];

export const RESUMES_COLUMNS = [
  { field: 'ResumeName', header: 'Resume Name', class: 'name-col', headerClass: 'name-col' },
  // { field: 'FilePath', header: 'Resume' },
  { field: 'action', header: 'Action', class: 'table-action-col', headerClass: 'table-action-col' }
];

export const InterviewType = {
  'Technical Interview - 1': 1,
  Practical: 2,
  'HR Round': 3,
  'Technical Interview - 2': 4,
  'Management Round': 5
};

export const Tab_INDEX = {
  'Personal Details': 0,
  'Resume Management': 1,
  // Skills: 2,
  'Project Details': 2,
  Education: 3,
  Employment: 4
};

export const InterviewTypeValue = {
  1: 'Technical Interview - 1',
  2: 'Practical',
  3: 'HR Round',
  4: 'Technical Interview - 2',
  5: 'Management Round'
};

export const PRACTICAL_RESULT_STATUS = {
  1: 'Selected',
  2: 'Not Selected',
  3: 'Further Review'
};

export const HR_OVERALL_FEEDBACK_STATUS = {
  1: 'Selected',
  2: 'Not Selected',
  3: 'Offered',
  4: 'In Discussion',
  5: 'Offer Rejected',
  6: 'Offer Accepted'
};

export const STATUS_INTERVIEW = {
  TECHNICAL_INTERVIEW_1_PENDING: 1,
  TECHNICAL_INTERVIEW_1_SCHEDULE: 2,
  TECHNICAL_INTERVIEW_1_COMPLETE: 3,
  PRACTICAL_PENDING: 4,
  PRACTICAL_SCHEDULE: 5,
  PRACTICAL_COMPLETE: 6,
  HR_PENDING: 7,
  HR_SCHEDULE: 8,
  HR_RESCHEDULE: 21,
  HR_COMPLETE: 9,
  CANCELLED: 10,
  TECHNICAL_INTERVIEW_1_RESCHEDULE: 11,
  PRACTICAL_RESCHEDULE: 12,
  TECHNICAL_INTERVIEW_2_PENDING: 13,
  TECHNICAL_INTERVIEW_2_SCHEDULE: 14,
  TECHNICAL_INTERVIEW_2_RESCHEDULE: 15,
  TECHNICAL_INTERVIEW_2_COMPLETE: 16,
  MANAGEMENT_PENDING: 17,
  MANAGEMENT_SCHEDULE: 18,
  MANAGEMENT_RESCHEDULE: 19,
  MANAGEMENT_COMPLETE: 20
};

export const INTERVIEW_STATUS_LIST = {
  1: 'Technical Interview - 1 Pending',
  2: 'Technical Interview - 1 Schedule',
  11: 'Technical Interview - 1 Reschedule',
  3: 'Technical Interview - 1 Complete',
  13: 'Technical Interview - 2 Pending',
  14: 'Technical Interview - 2 Schedule',
  15: 'Technical Interview - 2 Reschedule',
  16: 'Technical Interview - 2 Complete',
  4: 'Practical Pending',
  5: 'Practical Schedule',
  12: 'Practical Reschedule',
  6: 'Practical Complete',
  17: 'Management Pending',
  18: 'Management Schedule',
  19: 'Management Reschedule',
  20: 'Management Complete',
  7: 'HR Pending',
  8: 'HR Schedule',
  21: 'HR Reschedule',
  9: 'HR Complete',
  10: 'Cancelled'
};

export const INVITATION_STATUS = {
  PENDING: 1,
  ACCEPT: 2,
  REJECT: 3,
  ACCEPT_BY_OTHER: 4,
  AUTO_REJECT: 5,
  RESCHEDULED: 6
};

export const SIDEBAR_MENU = [
  {
    label: 'Home',
    items: [
      {
        label: 'Dashboard',
        to: ROUTES.DASHBOARD,
        src: dashboardIcon
      },
      {
        label: 'Edit Profile',
        to: ROUTES.PROFILE,
        src: editProfileIcon
      },
      {
        label: 'Interviews',
        to: ROUTES.INTERVIEWS,
        src: interViewIcon
      },
      {
        label: 'Interview Process',
        to: ROUTES.INTERVIEW_PROCCESS,
        src: interViewProcessIcon
      },
      {
        label: 'Jobs',
        to: ROUTES.JOBS,
        src: jobDesignationIcon
      },
      {
        label: 'Applied Jobs',
        to: ROUTES.APPLY_JOBS,
        src: AppliedJobIcon
      },
      {
        label: 'FAQs',
        to: ROUTES.FAQS,
        src: faqIcon
      }
    ]
  }
];

export const JOB_COLUMNS = [
  {
    field: 'JobTitle',
    header: 'Job Title',
    class: 'name-col',
    headerClass: 'name-col',
    sortBy: 'JobTitle'
  },
  {
    field: 'Skills',
    header: 'Skills'
  },
  {
    field: 'Salary',
    header: 'Salary',
    sortBy: 'Salary'
  },
  {
    field: 'Experience',
    header: 'Experience',
    sortBy: 'Experience'
  },
  {
    field: 'Position',
    header: 'Position',
    sortBy: 'Position'
  },
  {
    field: 'JobMode',
    header: 'Job Mode',
    sortBy: 'JobMode'
  },
  {
    field: 'action',
    header: 'Action',
    class: 'table-action-col, apply-job-btn',
    headerClass: 'table-action-col'
  }
];

export const APPLY_JOB_COLUMNS = [
  {
    field: 'JobTitle',
    header: 'Job Title',
    class: 'name-col',
    headerClass: 'name-col',
    sortBy: 'JobTitle'
  },
  {
    field: 'Position',
    header: 'Position',
    sortBy: 'Position'
  },
  {
    field: 'Salary',
    header: 'Salary',
    sortBy: 'Salary'
  },
  {
    field: 'ExpectedCTC',
    header: 'Expected CTC',
    sortBy: 'ExpectedCTC'
  },
  {
    field: 'DateCreated',
    header: 'Applied Date'
  },
  {
    field: 'Status',
    header: 'Status'
  }
];

export const APPLIED_JOB_STATUS = [
  { name: 'Applied', code: 1, class: 'applied_chip' },
  { name: 'CV Selected', code: 2, class: 'selected_chip' },
  { name: 'CV On Hold', code: 3, class: 'on_hold_chip' },
  { name: 'CV Not Selected', code: 4, class: 'not_selected_chip' },
  { name: 'Other', code: 5, class: 'other_chip' }
];

export const INTERVIEW_PROCESS_STEPS = [
  {
    number: 1,
    title: 'Update Profile',
    subtitle: 'Complete your profile before proceeding',
    content: (
      <ul>
        <li>Go to the Edit Profile section and update all required details.</li>
        <li>If you have an updated CV, you can use it to update your profile.</li>
        <li>Ensure your profile is complete and accurate before proceeding to the next step.</li>
        <li>Incomplete profiles may delay your application process.</li>
      </ul>
    )
  },
  {
    number: 2,
    title: 'Apply for a Job',
    subtitle: 'Find and apply for jobs matching your skills',
    content: (
      <>
        <ul>
          <li>Navigate to the Jobs page and search for roles that match your skills.</li>
          <li>Fill out the necessary details and submit your application.</li>
          <li>Ensure all required documents and information are provided.</li>
          <li>
            Candidates can reapply for a job after 6 months if their application was not selected.
          </li>
        </ul>
        <p>
          After applying for a job, you may receive one of the following statuses: Applied,
          CV Selected, CV Not Selected, CV On Hold, or Other.
        </p>
        <ul>
          <li>
            <strong>Applied:</strong> Your application has been submitted for the job.
          </li>
          <li>
            <strong>CV Selected:</strong> Your profile has been shortlisted for an interview.
          </li>
          <li>
            <strong>CV Not Selected:</strong> Your profile was not selected for this position.
          </li>
          <li>
            <strong>CV On Hold:</strong> Your profile looks impressive, but there are no current
            openings for this position.
          </li>
          <li>
            <strong>Other:</strong> Internal discussions are ongoing regarding your profile.
          </li>
        </ul>
      </>
    )
  },
  {
    number: 3,
    title: 'Interview Scheduling',
    subtitle: 'HR will review and schedule your interview',
    content: (
      <ul>
        <li>After applying, HR will review your profile and application.</li>
        <li>
          If shortlisted, your interview will be scheduled, and you can check the details under the
          Interviews tab.
        </li>
        <li>Ensure you are available for the scheduled time or request a reschedule if needed.</li>
      </ul>
    )
  },
  {
    number: 4,
    title: 'Interview Rounds',
    subtitle: 'Clear each round to proceed to the next',
    content: (
      <>
        <ol>
          <li>
            <strong>TC-1 Round:</strong> Technical screening and basic problem-solving.
          </li>
          <li>
            <strong>TC-2 Round:</strong> Advanced technical evaluation.
          </li>
          <li>
            <strong>Practical Round:</strong> Hands-on task or coding challenge.
          </li>
          <li>
            <strong>Management Round:</strong> Discussion with senior management.
          </li>
          <li>
            <strong>HR Round:</strong> Final discussion about culture fit and expectations.
          </li>
        </ol>
        <p>
          Each round has different states: Pending, Scheduled, Rescheduled, Completed, or Cancelled.
        </p>
        <ul>
          <li>
            <strong>Pending:</strong> Waiting for interviewer confirmation.
          </li>
          <li>
            <strong>Scheduled:</strong> The interviewer has confirmed the round.
          </li>
          <li>
            <strong>Rescheduled:</strong> The round has been rescheduled to a new time.
          </li>
          <li>
            <strong>Completed:</strong> The round has been successfully conducted.
          </li>
          <li>
            <strong>Cancelled:</strong> The round has been cancelled due to unforeseen
            circumstances.
          </li>
        </ul>
      </>
    )
  },
  {
    number: 5,
    title: 'Final Decision',
    subtitle: 'Await the hiring decision',
    content: (
      <>
        <ul>
          <li>After completing all rounds, await the final decision from the hiring team.</li>
          <li>You will be notified via email about the outcome of your application.</li>
          <li>If selected, further instructions will be provided for onboarding.</li>
        </ul>
      </>
    )
  }
];

const documentStyle = getComputedStyle(document.documentElement);
const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

export const barChartoprions = {
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      ticks: {
        color: textColorSecondary,
        font: {
          weight: 500
        }
      },
      grid: {
        display: false,
        drawBorder: false
      }
    },
    y: {
      ticks: {
        stepSize: 1,
        color: textColorSecondary
      },
      grid: {
        color: surfaceBorder,
        drawBorder: false
      }
    }
  }
};

export const RESUME_Tab_INDEX = {
  'User Details': 0,
  'Project Details': 1,
  'Education Details': 2,
  'Employment Details': 3,
};